import { useDispatch } from "react-redux";
import * as React from "react";
import { Fragment, useEffect } from "react";
import { Routes, Route } from "react-router-dom";
import Login from "./pages/Login/login";
import secureLocalStorage from "react-secure-storage";
import ResetPassword from "./pages/Login/ResetPassword";
import { getAllUsers, updateUser } from "./actions/user";
import NotFound from "./pages/Not Found/NotFound";
import ResetMyPassword from "./user page/ResetPassword";
import InternetConnectionMonitor from "./pages/Internet Connection/InternetConnection";
import { getInsurance } from "./actions/Insurance";
import { getAllUnapprovedInsurance } from "./actions/unApprovedInsurance";
import { allApprovedInsurance } from "./actions/approvedInsurance";
import { getAllRenewInsurance } from "./actions/RenewInsurance";
import { getMonthlyExpires } from "./actions/monthly";
import Insurance from "./pages/Insurance/Insurance";
import Report from "./pages/Report/Report";
import UserAccountPage from "./user page/UserAccountPage";
import Approval from "./pages/Approvals/Approvals";
import Analytics from "./pages/Insight/Insight";
import Restrict from "./pages/Restrict/Restrict";
import { Toaster } from "react-hot-toast";
import AppLayout from "./ui/AppLayout";
import ProtectedRoute from "./ui/ProtectedRoute";
import { HelmetProvider } from "react-helmet-async";
import TimeZoneCheckerModal from "./TimeZoneCheck/TimeZone";
const App = () => {
  const initialState = JSON.parse(secureLocalStorage.getItem("profile"));
  const [user, setUser] = React.useState(initialState);
  useEffect(() => {
    setUser(JSON.parse(secureLocalStorage.getItem("profile")));
  }, []);

  const dispatch = useDispatch();
  useEffect(() => {
    if (user) {
      dispatch(getAllUsers());
      dispatch(getInsurance());
      dispatch(getAllUnapprovedInsurance());
      dispatch(allApprovedInsurance());
      dispatch(getAllRenewInsurance());
      dispatch(getMonthlyExpires());
    }
  }, [dispatch, user]);

  React.useEffect(() => {
    if (user) {
      dispatch(
        updateUser(user?.results._id, {
          login: "yes",
          system: "insurance",
        })
      );
    }
  }, [dispatch, user]);

  let allowApprove = false;
  if (
    user?.results.risk_manager === "Administrator" ||
    user?.results.risk_manager === "Approver"
  ) {
    allowApprove = true;
  } else {
    allowApprove = false;
  }
  return (
    <HelmetProvider>
      <TimeZoneCheckerModal />
      {user?.results.risk_manager === "Restricted" ? (
        <Restrict />
      ) : (
        <div>
          <Fragment>
            <InternetConnectionMonitor />
            <Routes>
              <Route
                element={
                  <ProtectedRoute>
                    <AppLayout />
                  </ProtectedRoute>
                }
              >
                <Route path="/insurance/" element={<Analytics />} />
                <Route index element={<Analytics />} />

                <Route path="/insurance/report" element={<Report />} />
                <Route
                  path="/insurance/new-insurance"
                  element={<Insurance />}
                />
                {allowApprove && (
                  <Route path="/insurance/approvals" element={<Approval />} />
                )}
                <Route
                  path="/insurance/user-page"
                  element={<UserAccountPage />}
                />
              </Route>
              <Route
                path="/insurance/resetPassword"
                element={<ResetPassword />}
              />
              <Route path="/insurance/login" element={<Login />} />
              <Route
                path="/insurance/resetMyPassword/:token"
                element={<ResetMyPassword />}
              />
              <Route path="*" element={<NotFound />} />
            </Routes>
          </Fragment>
        </div>
      )}
      <Toaster
        position="top-center"
        gutter={10}
        containerStyle={{ top: 16 }}
        toastOptions={{
          success: { duration: 3000 },
          error: { duration: 6000 },
          style: {
            fontSize: "13px",
            fontWeight: 500,
            maxWidth: "460px",
            padding: "10px 14px",
            borderRadius: "999px",
            background: "#fff",
            color: "#0F1B24",
            border: "1px solid #E3E8EC",
            boxShadow: "0 8px 24px rgba(15, 27, 36, 0.12)",
          },
        }}
      />
    </HelmetProvider>
  );
};

export default App;
